import { ProductListAnalyticsService, RetailRocketService } from '@analytics/feature';
import { Injectable, Optional } from '@angular/core';

@Injectable()
export class RetailRocketCarouselStateService {
  //   тип алгоритма
  type: string;

  constructor(
    private retailRocketService: RetailRocketService,
    @Optional() private productListAnalyticsService?: ProductListAnalyticsService,
  ) {}

  init(type: string): void {
    this.type = type;
  }

  clickToAddToCart(code: string): void {
    this.retailRocketService.recomAddToCart(code, this.type, this.productListAnalyticsService?.getListName());
  }

  clickToLink(code: string): void {
    this.retailRocketService.recomMouseDown(code, this.type, this.productListAnalyticsService?.getListName());
  }
}
